import { useQuery } from '@tanstack/react-query'
import { fetchHousehold } from '@/api/households'

export function useHousehold() {
  return useQuery({
    queryKey: ['household'],
    queryFn: fetchHousehold,
    staleTime: Infinity,
  })
}
